exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a29c3ee6] .btn-xs{padding:1px 5px!important;display:inline-block!important}[data-v-a29c3ee6] .read-more-link:hover{text-decoration:underline!important}[data-v-a29c3ee6] .note-cell-container{display:flex;align-items:center;overflow:hidden}[data-v-a29c3ee6] .action-save{min-width:45px;line-height:1.2}[data-v-a29c3ee6] .tabulator-cell{display:flex;align-items:center}[data-v-a29c3ee6] .tabulator-col[field=row_save_btn]{overflow:visible!important}", ""]);

// exports
